var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 12.0002C1.5 11.8013 1.57902 11.6105 1.71967 11.4699C1.86032 11.3292 2.05109 11.2502 2.25 11.2502H19.9395L15.219 6.53122C15.0782 6.39039 14.9991 6.19938 14.9991 6.00021C14.9991 5.80105 15.0782 5.61004 15.219 5.46921C15.3598 5.32838 15.5508 5.24927 15.75 5.24927C15.9492 5.24927 16.1402 5.32838 16.281 5.46921L22.281 11.4692C22.3508 11.5389 22.4063 11.6216 22.4441 11.7128C22.4819 11.8039 22.5013 11.9016 22.5013 12.0002C22.5013 12.0989 22.4819 12.1965 22.4441 12.2877C22.4063 12.3788 22.3508 12.4615 22.281 12.5312L16.281 18.5312C16.1402 18.672 15.9492 18.7512 15.75 18.7512C15.5508 18.7512 15.3598 18.672 15.219 18.5312C15.0782 18.3904 14.9991 18.1994 14.9991 18.0002C14.9991 17.8011 15.0782 17.61 15.219 17.4692L19.9395 12.7502H2.25C2.05109 12.7502 1.86032 12.6712 1.71967 12.5305C1.57902 12.3899 1.5 12.1991 1.5 12.0002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.6f97284cc7a84b10d16f7376faa14368.svg";
export { ForwardRef as ReactComponent };